import React from 'react';
import Form from 'react-bootstrap/Form';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';
import { getIn } from 'formik';
import HelperText from '../HelperText';
import cn from 'classnames';
import styles from './ValidatedPhoneNumber.module.css';
import PropTypes from 'prop-types';

const ValidatedPhoneNumber = ({ field, form, label, placeholder, countryCode, ...props }) => {
    const { errors, touched, values, setFieldValue } = form;
    const isInvalid = !!getIn(errors, field.name) && getIn(touched, field.name);

    const fieldPath = field.name.split('.');
    const parentPath = fieldPath.slice(0, -1).join('.'); // Extract "entries.0"

    // Get countryCode from Formik state
    const storedCountryCode = getIn(values, `${parentPath}.countryCode`) || countryCode || '';

    const handlePhoneNumberChange = (phone, country) => {
        if (country?.dialCode !== storedCountryCode) {
            setFieldValue(`${parentPath}.countryCode`, country.dialCode);
        }
        setFieldValue(field.name, phone); // Always store full phone number
    };

    return (
        <Form.Group controlId={field.name} className={cn(props.className, styles.inputWrapper)}>
            {label && <Form.Label>{label}</Form.Label>}
            <Form.Row className="m-0">
                <PhoneInput
                    value={field.value} // Pass the full number as expected
                    placeholder={placeholder}
                    country="us" // Ensure correct country selection
                    onChange={handlePhoneNumberChange}
                    isValid={!isInvalid}
                    containerClass={isInvalid ? styles.inputError : ''}
                />
                {isInvalid && <HelperText>{getIn(errors, field.name)}</HelperText>}
            </Form.Row>
        </Form.Group>
    );
};

ValidatedPhoneNumber.propTypes = {
    field: PropTypes.object,
    form: PropTypes.object,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    countryCode: PropTypes.string,
    className: PropTypes.string,
};

export default ValidatedPhoneNumber;
